import PropTypes from "prop-types";
import { Snackbar, Alert } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import theme from "@/helpers/theme";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { SEVERITY } from "@/config/constants";
const AigSnackbar = ({ message, severity, open, handleClose, sxOverride }) => {
  const borderColor =
    severity === SEVERITY.SUCCESS
      ? "darkGreen"
      : severity === SEVERITY.WARNING
      ? "aigColor76"
      : severity === SEVERITY.ERROR
      ? "aigColor53"
      : "";
  const backColor =
    severity === SEVERITY.SUCCESS
      ? "aigSuccess"
      : severity === SEVERITY.WARNING
      ? "aigWarning"
      : severity === SEVERITY.ERROR
      ? "aigColor55"
      : "";
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      sx={{
        borderRadius: "0.25rem",
        border: `1px solid ${theme.palette.color[borderColor]} `,

        top: { xs: "3.56rem", md: "4.5rem !important" },
        zIndex: (theme) => theme.zIndex.tooltip + 2,
        ...sxOverride,
      }}
    >
      <Alert
        severity={severity}
        iconMapping={{
          warning: (
            <ErrorIcon
              style={{ color: `color.${borderColor}` }}
              fontSize="inherit"
            />
          ),
          success: (
            <CheckCircleIcon
              style={{ color: `color.${borderColor}` }}
              fontSize="inherit"
            />
          ),
          error: (
            <CancelIcon
              style={{ color: `color.${borderColor}` }}
              fontSize="inherit"
            />
          ),
        }}
        onClose={handleClose}
        sx={{
          width: "100%",
          backgroundColor: theme.palette.color[backColor],
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

AigSnackbar.propTypes = {
  handleClose: PropTypes.func,
  message: PropTypes.string,
  open: PropTypes.bool,
  severity: PropTypes.string,
  sxOverride: PropTypes.object,
};

export default AigSnackbar;
